import { getJson, postJson } from 'api/baseApi'

const token = localStorage.getItem('token')

export const addFolder = function (folderName, parentId, id) {
  let url = `http://localhost:5000/api/folder/${id}`
  return window.fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'authorization': 'Bearer ' + token
    },
    body: JSON.stringify({ name: folderName, parentFolderId: parentId })
  }).then(response => {
    if (response.status === 200) {
      return null
    } else {
      return response.json()
    }
  })
}

export const deleteFolder = function (id) {
  const url = `http://localhost:5000/api/folder/${id}`
  return window.fetch(url, {
    method: 'Delete',
    headers: {
      'Content-Type': 'application/json',
      'authorization': 'Bearer ' + token
    }
  }).then(response => {
    if (response.status === 200) {
      return null
    } else {
      return response.json()
    }
  })
}

export const cutFolder = function (folderToMoveId, destinationFolderId) {
  let url = `http://localhost:5000/api/folder/move/${folderToMoveId}/${destinationFolderId}`
  return window.fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'authorization': 'Bearer ' + token
    }
  }).then(response => {
    if (response.status === 200) {
      return null
    } else {
      return response.json()
    }
  })
}

export const copyFolder = function (folderToCopyId, destinationFolderId) {
  let url = `http://localhost:5000/api/folder/copy/${folderToCopyId}/${destinationFolderId}`
  return window.fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'authorization': 'Bearer ' + token
    }
  }).then(response => {
    if (response.status === 200) {
      return null
    } else {
      return response.json()
    }
  })
}

export const getFolderInfo = function (folderId) {
  return getJson({ url: `/api/server/folders/getfolderinfo/${folderId}` })
}

export const getFolderMetaSets = function () {
  return getJson({ url: `/api/server/property/sets` })
}

export const getFolderProjects = function () {
  return getJson({ url: `/api/server/projects/linkableprojects` })
}

export const getSnagstreamProjects = function () {
  return getJson({ url: `/api/server/folders/snagstream` })
}

export const getTemplates = function () {
  return getJson({ url: `/api/server/procedure/templates` })
}

export const getUsers = function () {
  return getJson({ url: `/api/server/usersandgroups/users` })
}

export const postFolderInfo = function (folderId, body) {
  return postJson({ url: `/api/server/folders/savefolderinfo/${folderId}`, data: body })
}

export const postMetadataSet = function (data) {
  return postJson({ url: `/api/server/property/link`, data: data })
}

export const postProject = function (data) {
  return postJson({ url: `/api/server/projects/linkfoldertoproject`, data: data })
}

export const unlinkProject = function (data) {
  return postJson({ url: `/api/server/projects/unlinkfolderandproject`, data: data })
}



// WEBPACK FOOTER //
// ./src/api/treemenuApi.js